<template>
    <div class="ai-document-content">
        <AIContentList
            v-if="hasPendingInvoices"
            :hasMargin="hasPendingQuotes || hasOngoingOpportunities"
        >
            <ul>
                <li>
                    <span class="typographies-paragraph-medium-semibold">
                        {{ $t.__('overview.tabs.TabSummary.paymentContent.pending_invoices') }}
                    </span>
                </li>
                <li>
                    {{ $t.__('overview.tabs.TabSummary.paymentContent.due_invoices') }} :
                    {{ dueInvoicesTotalAmount | numberformatCurrency }}
                </li>
                <li>
                    {{ $t.__('overview.tabs.TabSummary.paymentContent.late_invoices') }} :
                    {{ lateInvoicesTotalAmount | numberformatCurrency }}
                </li>
            </ul>
        </AIContentList>
        <AIContentList v-if="hasPendingQuotes" :hasMargin="hasOngoingOpportunities">
            <h4 class="typographies-paragraph-medium-semibold">
                {{ $t.__('overview.tabs.TabSummary.paymentContent.pending_quotes') }}
            </h4>
            <ul>
                <li>
                    {{ $t.__('overview.tabs.TabSummary.paymentContent.sent') }} :
                    {{ sentQuotesTotalAmount | numberformatCurrency }}
                </li>
                <li>
                    {{ $t.__('overview.tabs.TabSummary.paymentContent.read') }} :
                    {{ readQuotesTotalAmount | numberformatCurrency }}
                </li>
            </ul>
        </AIContentList>
        <AIContentList v-if="hasOngoingOpportunities" :hasMargin="false">
            <h4 class="typographies-paragraph-medium-semibold">
                {{ $t.__('overview.tabs.TabSummary.paymentContent.on_going_opportunities') }}
            </h4>
            <ul>
                <li v-for="opportunity in onGoingOpportunities" :key="opportunity.id">
                    {{ opportunity.name }} : {{ opportunity.potential | numberformatCurrency }} ({{
                        opportunity.funnel_step
                    }})
                </li>
            </ul>
        </AIContentList>
        <NoInvoicingData v-if="hasNoData" />
    </div>
</template>
<script>
import NoInvoicingData from 'vcomponents/AISummary/Content/NoInvoicingData.vue';
import AIContentList from 'vcomponents/AISummary/Content/AIContentList.vue';

export default {
    components: {
        NoInvoicingData,
        AIContentList,
    },
    inject: ['getSummary'],
    computed: {
        summary() {
            return this.getSummary();
        },
        financialRelationship() {
            return this.summary?.summary.input.customer_summary.financial_relationship
                ? this.summary.summary.input.customer_summary.financial_relationship
                : {};
        },
        hasPendingInvoices() {
            return (
                this.financialRelationship.pending_invoices &&
                this.financialRelationship.pending_invoices.length > 0
            );
        },
        dueInvoicesTotalAmount() {
            return this.financialRelationship.pending_invoices
                .filter((invoice) => invoice.status === 'due')
                .reduce((acc, invoice) => acc + +invoice.amount, 0);
        },
        lateInvoicesTotalAmount() {
            return this.financialRelationship.pending_invoices
                .filter((invoice) => invoice.status === 'late')
                .reduce((acc, invoice) => acc + +invoice.amount, 0);
        },
        hasNoData() {
            return (
                !this.hasPendingInvoices && !this.hasOngoingOpportunities && !this.hasPendingQuotes
            );
        },
        onGoingDeals() {
            return this.summary?.summary.input.customer_summary.ongoing_deals || {};
        },
        onGoingOpportunities() {
            return this.onGoingDeals.open_opportunities || [];
        },
        hasOngoingOpportunities() {
            return this.onGoingOpportunities.length > 0;
        },
        pendingQuotes() {
            return this.onGoingDeals.pending_quotes || [];
        },
        hasPendingQuotes() {
            return this.pendingQuotes.length > 0;
        },
        sentQuotesTotalAmount() {
            return this.pendingQuotes
                .filter((quote) => quote.step === 'sent')
                .reduce((acc, quote) => acc + +quote.total_amount, 0);
        },
        readQuotesTotalAmount() {
            return this.pendingQuotes
                .filter((quote) => quote.step === 'read')
                .reduce((acc, quote) => acc + +quote.total_amount, 0);
        },
    },
};
</script>
<style lang="scss" scoped>
.ai-document-content {
    h4 {
        margin: 0;
    }

    ul {
        list-style-type: none;
        margin: 0;
        padding: 0;
    }
}
</style>
